var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contract-name" },
    [
      _vm.applyType === "signList"
        ? [
            _vm.signInfo.status === 0 || _vm.signInfo.status === -1
              ? [
                  _vm.signInfo.selfSign === 1
                    ? _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content: _vm.signInfo.name,
                            placement: "bottom-start"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.handleClickLookContract(
                                    _vm.signInfo.signNo,
                                    _vm.signInfo.approveId
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.signInfo.name))]
                          )
                        ]
                      )
                    : _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content: _vm.signInfo.name,
                            placement: "bottom-start"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.handleClickLookContract({
                                    applyNo: _vm.signInfo.applyNo
                                  })
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.signInfo.name))]
                          )
                        ]
                      )
                ]
              : _vm.signInfo.status === 1
              ? [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content: _vm.signInfo.name,
                        placement: "bottom-start"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          on: {
                            click: function($event) {
                              return _vm.handleClickLookContract({
                                applyNo: _vm.signInfo.applyNo
                              })
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.signInfo.name))]
                      )
                    ]
                  )
                ]
              : _vm.signInfo.status === -5 || _vm.signInfo.status === 2
              ? [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content: _vm.signInfo.name,
                        placement: "bottom-start"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          on: {
                            click: function($event) {
                              return _vm.handleClickLookContract({
                                applyNo: _vm.signInfo.applyNo
                              })
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.signInfo.name))]
                      )
                    ]
                  )
                ]
              : _vm.signInfo.status === -6
              ? [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content: _vm.signInfo.name,
                        placement: "bottom-start"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          on: {
                            click: function($event) {
                              return _vm.$message.error("文件已过期")
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.signInfo.name))]
                      )
                    ]
                  )
                ]
              : [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content: _vm.signInfo.name || _vm.signInfo.contractName,
                        placement: "bottom-start"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          on: {
                            click: function($event) {
                              return _vm.handleClickLookContract({
                                applyNo: _vm.signInfo.applyNo
                              })
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.signInfo.name || _vm.signInfo.contractName
                            )
                          )
                        ]
                      )
                    ]
                  )
                ]
          ]
        : _vm.applyType === "applyList"
        ? [
            _vm.signInfo.status === 0
              ? [
                  _vm.signInfo.selfSign === 1
                    ? _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content: _vm.signInfo.name,
                            placement: "bottom-start"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.handleClickLookContract(
                                    _vm.signInfo.signNo,
                                    _vm.signInfo.approveId
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.signInfo.name))]
                          )
                        ]
                      )
                    : _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content: _vm.signInfo.name,
                            placement: "bottom-start"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.handleClickLookContract({
                                    applyNo: _vm.signInfo.applyNo
                                  })
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.signInfo.name))]
                          )
                        ]
                      )
                ]
              : _vm.signInfo.status === -6
              ? [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content: _vm.signInfo.name,
                        placement: "bottom-start"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          on: {
                            click: function($event) {
                              return _vm.$message.error("文件已过期")
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.signInfo.name))]
                      )
                    ]
                  )
                ]
              : [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content: _vm.signInfo.name || _vm.signInfo.contractName,
                        placement: "bottom-start"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          on: {
                            click: function($event) {
                              return _vm.handleClickLookContract({
                                applyNo: _vm.signInfo.applyNo
                              })
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.signInfo.name || _vm.signInfo.contractName
                            )
                          )
                        ]
                      )
                    ]
                  )
                ]
          ]
        : _vm._e(),
      _c("goto-auth", { attrs: { default: _vm.authDialog } })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e3b549b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3b549b0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/apply-list/contract-name-member.vue
// module id = vxhc
// module chunks = 23 24